<template>
  <div class="product-details-dimensions" v-if="technicalData">
    <a
      :href="technicalData"
      download
      target="blank"
      class="product-details-dimensions__download"
    >
      <CustomCta :is-full-width="true">
        {{ $t('Download the technical sheet') }}
      </CustomCta>
    </a>
    <a
      :href="technicalData"
      download
      target="blank"
      class="product-details-dimensions__download"
    >
      <nuxt-img
        class="product-details-dimensions__image"
        :src="`${technicalData}?w=1000`"
      />
    </a>
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { CustomSelect, CustomCta } from '~/components/General';

export default defineComponent({
  name: 'ProductDetailsDimensions',
  components: {
    CustomSelect,
    CustomCta,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const technicalData = computed(
      () =>
        props.product.configurable_product_options_selection?.media_gallery
          ?.filter((image) => image?.roles?.includes('small_image'))
          .at(-1)?.url
    );

    return {
      technicalData,
    };
  },
});
</script>

<style lang="scss" scoped>
.product-details-dimensions {
  &__title {
    @include label-s;
    padding-bottom: 0.625rem;
  }
  &__select {
    padding-bottom: 2.5rem;
    &__label {
      @include paragraph-m;
      padding-bottom: 0.625rem;
    }
  }
  &__image {
    max-width: calc(100vw - 2.5rem);
  }
  &__download {
    @include pointer;
  }
  @include from-desktop-min {
    &__select {
      padding-bottom: 3.625rem;
    }
    &__image {
      max-width: calc(50vw - 10rem);
    }
  }
}
</style>
